<template>
  <div class="about">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow eyebrow-light">{{ $t('about.hero.eyebrow') }}</span>
        <h1>{{ $t('about.hero.title') }}</h1>
        <p>{{ $t('about.hero.subtitle') }}</p>
      </div>
    </section>

    <section class="section">
      <div class="container grid grid-2 mv-grid">
        <div class="card">
          <IconBadge icon="target" tone="green" size="lg" />
          <h2>{{ $t('about.mission.title') }}</h2>
          <p>{{ $t('about.mission.text') }}</p>
        </div>
        <div class="card">
          <IconBadge icon="eye" tone="amber" size="lg" />
          <h2>{{ $t('about.vision.title') }}</h2>
          <p>{{ $t('about.vision.text') }}</p>
        </div>
      </div>
    </section>

    <section class="section section-alt">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">{{ $t('about.approach.eyebrow') }}</span>
          <h2>{{ $t('about.approach.title') }}</h2>
        </div>
        <div class="grid grid-3">
          <div class="card">
            <IconBadge icon="users" tone="navy" />
            <h3>{{ $t('about.approach.communityLed.title') }}</h3>
            <p>{{ $t('about.approach.communityLed.text') }}</p>
          </div>
          <div class="card">
            <IconBadge icon="shield" tone="rose" />
            <h3>{{ $t('about.approach.advocacy.title') }}</h3>
            <p>{{ $t('about.approach.advocacy.text') }}</p>
          </div>
          <div class="card">
            <IconBadge icon="heart" tone="amber" />
            <h3>{{ $t('about.approach.partnership.title') }}</h3>
            <p>{{ $t('about.approach.partnership.text') }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">{{ $t('about.values.eyebrow') }}</span>
          <h2>{{ $t('about.values.title') }}</h2>
        </div>
        <div class="grid grid-4">
          <div class="card value-card" v-for="v in values" :key="v.key">
            <IconBadge :icon="v.icon" tone="green" size="sm" />
            <h3>{{ $t(`about.values.${v.key}.title`) }}</h3>
            <p>{{ $t(`about.values.${v.key}.text`) }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-band">
      <div class="container cta-inner">
        <h2>{{ $t('about.cta.title') }}</h2>
        <p>{{ $t('about.cta.text') }}</p>
        <div class="hero-actions">
          <router-link to="/contact" class="btn btn-outline">{{ $t('about.cta.getInvolved') }}</router-link>
          <router-link to="/donate" class="btn btn-accent">{{ $t('nav.donate') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import IconBadge from '@/components/IconBadge.vue';

export default {
  name: 'AboutUs',
  components: { IconBadge },
  data() {
    return {
      values: [
        { key: 'compassion', icon: 'heart' },
        { key: 'integrity', icon: 'check' },
        { key: 'sustainability', icon: 'tree' },
        { key: 'inclusion', icon: 'users' },
      ],
    };
  },
};
</script>

<style scoped>
.page-hero { background: linear-gradient(135deg, var(--charcoal-dark), var(--charcoal)); color: #fff; padding: 76px 0; text-align: center; }
.eyebrow-light { color: #8FDDD8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 700; font-size: 0.8rem; }
.page-hero h1 { font-size: clamp(1.7rem, 3.4vw, 2.3rem); margin: 12px 0 10px; }
.page-hero p { color: rgba(255,255,255,0.88); margin: 0; }

.mv-grid .card { text-align: left; }
.mv-grid h2 { margin: 14px 0 10px; color: var(--charcoal); }
.mv-grid p { color: var(--muted); margin: 0; }

.grid-3 .card, .value-card { text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; }
.grid-3 h3, .value-card h3 { color: var(--charcoal); margin-top: 6px; }
.grid-3 p, .value-card p { color: var(--muted); font-size: 0.92rem; margin: 0; }

.cta-band { background: var(--charcoal); color: #fff; text-align: center; padding: 60px 0; }
.cta-inner p { margin: 10px 0 26px; color: rgba(255,255,255,0.92); }
.hero-actions { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
.cta-band .btn-outline { border-color: rgba(255,255,255,0.8); color: #fff; }
</style>
